
interface ChatHeaderProps {
  botName: string;
  botLogo?: string;
  primaryColor: string;
  secondaryColor: string;
  fallbackImage: string;
}

export default function ChatHeader({
  botName,
  botLogo,
  primaryColor,
  secondaryColor,
  fallbackImage,
}: ChatHeaderProps) {
  
  return (
    <div
      className="px-5 py-4 flex items-center justify-between text-white"
      style={{
        background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
      }}
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center backdrop-blur-sm overflow-hidden shrink-0">
          <img
            src={botLogo || fallbackImage}
            alt="Bot"
            className="w-full h-full object-cover"
            onError={(e) => (e.currentTarget.src = fallbackImage)}
          />
        </div>
        <div>
          <h3 className="font-bold text-base">{botName}</h3>
          <div className="flex items-center gap-1.5">
            <div className="w-2 h-2 bg-green-400 rounded-full"></div>
            <span className="text-xs text-white text-opacity-90">Online</span>
          </div>
        </div>
      </div>
    </div>
  );
}
